const referralsActions = {
    //REFERRALS
    LOAD_NOT_OWNED_REFERRALS_START: 'LOAD_NOT_OWNED_REFERRALS_START',
    LOAD_NOT_OWNED_REFERRALS_SUCCESS: 'LOAD_NOT_OWNED_REFERRALS_SUCCESS',
    LOAD_NOT_OWNED_REFERRALS_FAILED: 'LOAD_NOT_OWNED_REFERRALS_FAILED',

    LOAD_OWNED_REFERRALS_START: 'LOAD_OWNED_REFERRALS_START',
    LOAD_OWNED_REFERRALS_SUCCESS: 'LOAD_OWNED_REFERRALS_SUCCESS',
    LOAD_OWNED_REFERRALS_FAILED: 'LOAD_OWNED_REFERRALS_FAILED',

    //CREATE_REFERRAL
    CREATE_REFERRAL_START: "CREATE_REFERRAL_START",
    CREATE_REFERRAL_SUCCESS: "CREATE_REFERRAL_SUCCESS",
    CREATE_REFERRAL_FAILED: "CREATE_REFERRAL_FAILED",

    //EDIT_REFERRAL
    EDIT_REFERRAL_START: "EDIT_REFERRAL_START",
    EDIT_REFERRAL_SUCCESS: "EDIT_REFERRAL_SUCCESS",
    EDIT_REFERRAL_FAILED: "EDIT_REFERRAL_FAILED",

    //DELETE_REFERRAL
    DELETE_REFERRAL_START: 'DELETE_REFERRAL_START',
    DELETE_REFERRAL_SUCCESS: 'DELETE_REFERRAL_SUCCESS',
    DELETE_REFERRAL_FAILED: 'DELETE_REFERRAL_FAILED',

    //CLEAR_FLAGS
    CLEAR_FLAGS: 'CLEAR_FLAGS',

    // SEARCH
    SET_SEARCH_REFERRAL_TEXT: 'SET_SEARCH_REFERRAL_TEXT',

    // Referrals Actions
    createLoadNotOwnedReferralsActionStart: () => {
        return {
            type: referralsActions.LOAD_NOT_OWNED_REFERRALS_START,
        };
    },
    createLoadNotOwnedReferralsActionSuccess: (referrals) => {
        return {
            type: referralsActions.LOAD_NOT_OWNED_REFERRALS_SUCCESS,
            payload: referrals,
        };
    },
    createLoadNotOwnedReferralsActionFailed: (referralsError) => {
        return {
            type: referralsActions.LOAD_NOT_OWNED_REFERRALS_FAILED,
            payload: referralsError,
        };
    },
    createLoadOwnedReferralsActionStart: () => {
        return {
            type: referralsActions.LOAD_OWNED_REFERRALS_START,
        };
    },
    createLoadOwnedReferralsActionSuccess: (referrals) => {
        return {
            type: referralsActions.LOAD_OWNED_REFERRALS_SUCCESS,
            payload: referrals,
        };
    },
    createLoadOwnedReferralsActionFailed: (referralsError) => {
        return {
            type: referralsActions.LOAD_OWNED_REFERRALS_FAILED,
            payload: referralsError,
        };
    },
    createCreateReferralActionStart: (referral) => {
        return {
            type: referralsActions.CREATE_REFERRAL_START,
            payload: referral,
        };
    },
    createCreateReferralActionSuccess: (referralsSuccess) => {
        return {
            type: referralsActions.CREATE_REFERRAL_SUCCESS,
            payload: referralsSuccess,
        };
    },
    createCreateReferralActionFailed: (referralsError) => {
        return {
            type: referralsActions.CREATE_REFERRAL_FAILED,
            payload: referralsError,
        };
    },
    createEditReferralActionStart: (referral) => {
        return {
            type: referralsActions.EDIT_REFERRAL_START,
            payload: referral,
        };
    },
    createEditReferralActionSuccess: (referralsSuccess) => {
        return {
            type: referralsActions.EDIT_REFERRAL_SUCCESS,
            payload: referralsSuccess,
        };
    },
    createEditReferralActionFailed: (referralsError) => {
        return {
            type: referralsActions.EDIT_REFERRAL_FAILED,
            payload: referralsError,
        };
    },
    createDeleteReferralActionStart: (payload) => {
        return {
            type: referralsActions.DELETE_REFERRAL_START,
            payload: payload,
        };
    },
    createDeleteReferralActionSuccess: (referralsSuccess) => {
        return {
            type: referralsActions.DELETE_REFERRAL_SUCCESS,
            payload: referralsSuccess,
        };
    },
    createDeleteReferralActionFailed: (referralsError) => {
        return {
            type: referralsActions.DELETE_REFERRAL_FAILED,
            payload: referralsError,
        };
    },
    clearFlags: (payload) => {
        return {
            type: referralsActions.CLEAR_FLAGS,
            payload: payload,
        };
    },
    setSearchReferalText: (payload) => {
        return {
            type: referralsActions.SET_SEARCH_REFERRAL_TEXT,
            payload,
        };
    },
};

export default referralsActions;
